import { dashboardRoutes } from "#/routes/dashboardRoutes";

export const getFirstAllowedRoute = (allowedRoutes: string[] | null | undefined): string => {
  if (!allowedRoutes || allowedRoutes.length === 0) {
    return "/dashboard";
  }

  // Flatten dashboardRoutes to get all routes in menu order
  const allRoutesInOrder: string[] = [];

  dashboardRoutes.forEach(route => {
    allRoutesInOrder.push(route.href);
    if (route.children) {
      route.children.forEach(child => {
        allRoutesInOrder.push(route.href + child.href);
      });
    }
  });

  // Find first route in menu order that exists in allowedRoutes
  for (const route of allRoutesInOrder) {
    if (allowedRoutes.includes(route)) {
      return route;
    }
  }

  // Fallback to dashboard if no match found
  return "/dashboard";
};
